import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export default function CertificationTab({ formData, setFormData }) {
  const addCertification = () => {
    setFormData(prev => ({
      ...prev,
      certifications: [
        ...prev.certifications,
        {
          name: '',
          category: '',
          organizer: '',
          certificate_number: '',
          issue_date: '',
          expiry_date: '',
        },
      ],
    }));
  };

  const updateCertification = (index, field, value) => {
    const certs = [...formData.certifications];
    certs[index][field] = value;
    setFormData(prev => ({ ...prev, certifications: certs }));
  };

  const removeCertification = index => {
    setFormData(prev => ({
      ...prev,
      certifications: prev.certifications.filter((_, i) => i !== index),
    }));
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold">Sertifikasi & Pelatihan</h3>
        <p className="text-gray-500 text-sm">Daftar sertifikasi dan pelatihan yang dimiliki</p>
      </div>

      <AnimatePresence>
        {formData.certifications.map((cert, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: -20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -20, scale: 0.95 }}
            transition={{ duration: 0.3 }}
            className="border-2 rounded-lg p-4 space-y-3"
          >
            <div className="flex justify-between items-start">
              <h4 className="font-medium">Sertifikasi #{index + 1}</h4>
              <button
                type="button"
                onClick={() => removeCertification(index)}
                className="text-red-500 hover:text-red-700 transition-colors duration-300"
              >
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
            <div className="grid md:grid-cols-2 gap-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Nama Sertifikasi
                </label>
                <input
                  type="text"
                  value={cert.name}
                  onChange={e => updateCertification(index, 'name', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Kategori</label>
                <input
                  type="text"
                  value={cert.category}
                  onChange={e => updateCertification(index, 'category', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Penyelenggara
                </label>
                <input
                  type="text"
                  value={cert.organizer}
                  onChange={e => updateCertification(index, 'organizer', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  No. Sertifikat
                </label>
                <input
                  type="text"
                  value={cert.certificate_number}
                  onChange={e => updateCertification(index, 'certificate_number', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Tanggal Terbit
                </label>
                <input
                  type="date"
                  value={cert.issue_date}
                  onChange={e => updateCertification(index, 'issue_date', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Tanggal Expired
                </label>
                <input
                  type="date"
                  value={cert.expiry_date}
                  onChange={e => updateCertification(index, 'expiry_date', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                />
              </div>
            </div>
          </motion.div>
        ))}
      </AnimatePresence>

      <motion.button
        type="button"
        onClick={addCertification}
        whileHover={{ scale: 1.01 }}
        whileTap={{ scale: 0.98 }}
        className="w-full py-2 border-2 border-dashed rounded-lg text-gray-600 hover:border-emerald-500 hover:text-emerald-600 hover:bg-emerald-50 flex items-center justify-center gap-2 transition-colors duration-300"
      >
        <Plus className="w-4 h-4" /> Tambah Sertifikasi
      </motion.button>
    </div>
  );
}
